module.exports = __webpack_public_path__ + "static/media/PG.31bec0d6.svg";